import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../modules/react/components/stateless/Icon';
import OverlayButton from './OverlayButton';
import styles from './PublishButton.scss';

const propTypes = {
  authText: PropTypes.string,
  disabled: PropTypes.bool,
  helpText: PropTypes.string.isRequired,
  publishable: PropTypes.bool,
  publishing: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  disableEnUsPage: PropTypes.bool.isRequired,
  restoreMode: PropTypes.bool,
};

const defaultProps = {
  authText: undefined,
  disabled: undefined,
  publishable: undefined,
  publishing: undefined,
  restoreMode: false,
};

const PublishButton = ({
  authText, disabled, helpText, publishable, publishing, onClick, disableEnUsPage, restoreMode,
}) => {
  let props;
  if (restoreMode) {
    props = {
      icon: 'warning',
      children: 'Restore',
      context: 'positive',
    };
  } else if (publishable) {
    props = {
      icon: 'warning',
      children: 'Publish',
      context: 'positive',
    };
  } else {
    props = {
      icon: 'success',
      children: 'Published',
      context: 'positive',
      inverted: true,
      borderless: true,
    };
  }

  const style = disabled && !publishable ?
    { opacity: 1 } :
    {};

  const overlayText = (
    <React.Fragment>
      {helpText}
      {authText &&
        <div className={styles.unauthorized}>
          <Icon id="circle-lock" label="Unauthorized" />
          {authText}
        </div>
      }
    </React.Fragment>
  );

  return (
    !disableEnUsPage &&
    <OverlayButton
      size="sm"
      {...props}
      style={style}
      onClick={onClick}
      disabled={disabled}
      loading={publishing}
      overlayText={overlayText}
      className={styles.button}
    />
  );
};

PublishButton.propTypes = propTypes;
PublishButton.defaultProps = defaultProps;

export default PublishButton;
